module.exports = __webpack_public_path__ + "363fa0a518e3142cf3d601c8f28a797a.svg";